import {ChangeDetectorRef, Component, Input, NgZone, ViewChild} from '@angular/core';
import {
  Alert,
  AlertController,
  Content,
  IonicPage,
  Loading,
  LoadingController,
  NavController,
  NavParams,
  Platform,
  RadioButton, TextInput
} from 'ionic-angular';
import {AppConfigPage} from "../app-config/app-config";
import {Serializable, Serialize} from "ts-serializer";
import {ReaderService} from "../../providers/reader.service";
import {VizixService} from "../../providers/vizix.service";
import {TranslateService} from "@ngx-translate/core";
import {Keyboard} from '@ionic-native/keyboard';
import {
  CONFIGURATION_ERROR,
  INVALID_FORMAT,
  NAV_PARAM_RETURN_PAGE,
  NOT_FOUND,
  READER_TYPE_BARCODE,
  READER_TYPE_RFID,
  RETURN_PAGE_IDENTIFY_TAG,
  SERVER_ERROR,
  TAG_INFORMATION_SOURCE_IDENTIFY_TAG,
  UNKNOWN_ERROR, VALIDATION_INPUT_TAG
} from "../../app/app.constants";
import {ErrorResponse} from "../../models/ErrorResponse";
import {TagReadBarcodeResponse} from "../../models/reader-model/tagReadBarcodeResponse";
import {Subscription} from "rxjs/Subscription";
import {TagInformationService} from "../../providers/tag.information.service";
import {ReaderDeviceGroup} from "../../models/reader-model/readerDeviceGroup";

@IonicPage()
@Component({
  selector: 'page-identify-tag',
  templateUrl: 'identify-tag.html'
})

@Serialize({})
export class IdentifyTagPage extends Serializable {

  private tag = '[IDENTIFY_TAG]';

  public isRfidDisabled = true;
  public dataFields: any = [];
  public tagText: string = "";
  public result: any;
  public isReaderAvailable: boolean = false;
  public response: any;
  public is_resopnse_tag = false;
  public barcodeChecked: boolean = false;
  public rfidChecked: boolean = false;
  public is_loading: boolean = false;
  public is_alert: boolean = false;

  public loading: Loading;
  public alertReaderError: Alert;
  public alertInvalidFormatError: Alert;
  public alertReaderDisconnectedError: Alert;
  public alertNoInformationFoundError: Alert;
  public alertServerError: Alert;
  public alertConfigurationError: Alert;
  public alertReportError: Alert;
  public alertUnknownError: Alert;

  private readerDisconnectSubscription: Subscription;

  public isKeyboardOpen: boolean = false;
  private keyboardHideSubscription: Subscription;
  public isCameraEnabled: boolean = false;

  private isFirstLoadInitializing: boolean = false;
  private readRFIDSubscription: Subscription;

  public inputError: string = '';

  @ViewChild(Content) content: Content;
  @ViewChild('rdbtnBarcode') radioButtonBarcode: RadioButton;
  @ViewChild('rdbtnRfid') radioButtonRFID: RadioButton;
  @ViewChild('inputItem') inputTagField: TextInput;

  private barcodeAttempts = 0;
  private isPopActive: boolean = false;
  private isAndroid: boolean = false;

  public source = TAG_INFORMATION_SOURCE_IDENTIFY_TAG;
  private inputErrorTimeout: any;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public readerService: ReaderService,
              public  vizixService: VizixService,
              private cdr: ChangeDetectorRef,
              public loadingCtrl: LoadingController,
              public alertCtrl: AlertController,
              public translate: TranslateService,
              private keyboard: Keyboard,
              private platform: Platform,
              private ngZone: NgZone,
              private tagInformationService: TagInformationService) {
    super();
    this.initAlerts();
    this.isAndroid = this.platform.is('android');
  }

  initAlerts() {
    this.initAlertReaderDisconnectedError();
    this.initAlertReaderError();
    this.initAlertInvalidFormatError();
    this.initAlertConfigurationError();
    this.initAlertNoInformationFoundError();
    this.initAlertServerError();
    this.initAlertReportError();
    this.initAlertUnknownError();
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertReaderError() {
    this.alertReaderError = this.alertCtrl.create({
      title: this.translate.instant('identify_tag.alerts.reader_error.title'),
      message: this.translate.instant('identify_tag.alerts.reader_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('identify_tag.alerts.reader_error.ok'),
          handler: () => {
            this.is_alert = false;
            this.initAlertReaderError(); // We call this recursively because the alert is destroyed on dismiss
            // this.goBack();
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertInvalidFormatError() {
    this.alertInvalidFormatError = this.alertCtrl.create({
      title: this.translate.instant('identify_tag.alerts.invalid_format.title'),
      message: this.translate.instant('identify_tag.alerts.invalid_format.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('identify_tag.alerts.invalid_format.ok'),
          handler: () => {
            this.is_alert = false;
            this.initAlertInvalidFormatError(); // We call this recursively because the alert is destroyed on dismiss
            this.clearVariables();
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertConfigurationError() {
    this.alertConfigurationError = this.alertCtrl.create({
      title: this.translate.instant('identify_tag.alerts.configuration_error.title'),
      message: this.translate.instant('identify_tag.alerts.configuration_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('identify_tag.alerts.configuration_error.ok'),
          handler: () => {
            this.is_alert = false;
            this.initAlertConfigurationError(); // We call this recursively because the alert is destroyed on dismiss
            this.clearVariables();
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error uploading CycleCount
  initAlertReportError() {
    this.alertReportError = this.alertCtrl.create({
      title: this.translate.instant('identify_tag.alerts.report_error.title'),
      message: this.translate.instant('identify_tag.alerts.report_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('identify_tag.alerts.report_error.ok'),
          handler: () => {
            this.initAlertReportError(); // We call this recursively because the alert is destroyed on dismiss
          }
        }
      ]
    });
  }

  // Alert that shows when the reader disconnects
  initAlertReaderDisconnectedError() {
    this.alertReaderDisconnectedError = this.alertCtrl.create({
      title: this.translate.instant('identify_tag.alerts.reader_disconnected.title'),
      message: this.translate.instant('identify_tag.alerts.reader_disconnected.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('identify_tag.alerts.reader_disconnected.ok'),

          handler: () => {
            this.is_alert = false;
            if (!this.isPopActive) {
              this.isPopActive = true;
              this.navCtrl.pop();
            }
            // this.initAlertReaderDisconnectedError(); // We call this recursively because the alert is destroyed on dismiss
            // this.clearInput(true);
          }
        }
      ]
    });
  }

  // Alert that shows when no information is found for the input tag
  initAlertNoInformationFoundError() {
    this.alertNoInformationFoundError = this.alertCtrl.create({
      title: this.translate.instant('identify_tag.alerts.no_information.title'),
      //message: this.translate.instant('identify_tag.alerts.no_information.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('identify_tag.alerts.no_information.ok'),
          handler: () => {
            this.is_alert = false;
            this.initAlertNoInformationFoundError(); // We call this recursively because the alert is destroyed on dismiss
            this.clearVariables();
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error in a server request
  initAlertServerError() {
    this.alertServerError = this.alertCtrl.create({
      title: this.translate.instant('identify_tag.alerts.server_error.title'),
      message: this.translate.instant('identify_tag.alerts.server_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('identify_tag.alerts.server_error.ok'),
          handler: () => {
            this.is_alert = false;
            this.initAlertServerError(); // We call this recursively because the alert is destroyed on dismiss
            this.clearVariables();
          }
        }
      ]
    });
  }

  // Alert that shows when there is an error in a server request
  initAlertUnknownError() {
    this.alertUnknownError = this.alertCtrl.create({
      title: this.translate.instant('find_item.alerts.unknown_error.title'),
      message: this.translate.instant('find_item.alerts.unknown_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('find_item.alerts.unknown_error.ok'),
          handler: () => {
            this.initAlertUnknownError(); // We call this recursively because the alert is destroyed on dismiss
            this.clearVariables();
          }
        }
      ]
    });
  }

  // On view load will set first reader configuration if reader is connected
  ionViewDidLoad() {
    this.isFirstLoadInitializing = true;
    this.keyboard.onKeyboardShow().subscribe(() => {
      this.isKeyboardOpen = true;
    });

    this.keyboard.onKeyboardHide().subscribe(() => {
      this.isKeyboardOpen = false;
    });

    this.showLoadingInitializingReader();

    this.initReaderStatusListener();
    this.readerService.isConnected(true).subscribe(
      (response: any) => {
        console.log(this.tag, 'Reader connected', response);
        if (response) {
          this.isRfidDisabled = false;
          let defaultMode: string = this.vizixService.configurationApp.IdentifyItemConfiguration.DefaultMode.value;
          if (defaultMode == READER_TYPE_BARCODE) {
            this.changeBarcodeMode();
            this.barcodeChecked = true;
            this.rfidChecked = false;
          } else if (defaultMode == READER_TYPE_RFID) {
            this.changeRFIDMode();
            this.barcodeChecked = false;
            this.rfidChecked = true;
          } else {
            this.changeBarcodeMode();
            this.barcodeChecked = true;
            this.rfidChecked = false;
          }
        }
        else {
          this.isRfidDisabled = true;
          this.barcodeChecked = true;
          this.rfidChecked = false;
          this.changeBarcodeMode();
        }
      }, (error) => {
        this.isReaderAvailable = false;
        console.log(this.tag, 'ERROR', error);
      }
    );

    this.vizixService.VizixUpdateReportDefinitionIdentifyTag();

    if (this.isReaderAvailable) {
      this.changeBarcodeMode();
    }
    this.dismissLoading();
  }

  openBarcodeCamera() {
    this.readerService.initBarcodeCameraScan().then((barcode) => {
      this.tagText = barcode.value;
      this.dismissAlerts();
      this.validateAndHideKeyboard(barcode.value);
    }, (error) => {
      console.log(this.tag, 'Error barcode camera', error);
    });
  }

  ionViewDidEnter() {
    this.content.resize();
    this.cdr.reattach();
    this.cdr.detectChanges();
  }

  // Called when the view is about to pop
  ionViewWillLeave() {
    if (this.readerDisconnectSubscription) {
      this.readerDisconnectSubscription.unsubscribe();
    }
    if (this.readRFIDSubscription) {
      this.readRFIDSubscription.unsubscribe();
    }

    this.stopReader();
    this.cdr.detach();
  }

  // Go to configuration module
  goToAppConfig() {
    let returnNavParams = {};
    returnNavParams[NAV_PARAM_RETURN_PAGE] = RETURN_PAGE_IDENTIFY_TAG;
    this.navCtrl.push(AppConfigPage, returnNavParams);
  }

  validateAndHideKeyboard(tag: string) {
    if (this.platform.is('cordova') && this.isKeyboardOpen) {
      this.keyboard.close();
      this.keyboardHideSubscription = this.keyboard.onKeyboardHide().subscribe(() => {
        this.isKeyboardOpen = false;
        this.tagInformationService.setTag(tag, this.source);
        this.keyboardHideSubscription.unsubscribe();
      });
    } else {
      this.tagInformationService.setTag(tag, this.source);
    }
  }

  setLoadingValue(isTagInformationLoading:boolean){
   this.is_loading=isTagInformationLoading;
  }


  showLoadingWait() {
    if (!this.is_loading) {
      this.loading = this.loadingCtrl.create({
        content: this.translate.instant('identify_tag.loadings.please_wait')
      });
      this.is_loading = true;
      this.loading.present();
    }
  }

  showLoadingInitializingReader() {
    if (!this.is_loading) {
      this.loading = this.loadingCtrl.create({
        content: this.translate.instant('identify_tag.loadings.initializing_scanner')
      });
      this.is_loading = true;
      this.loading.present();
    }
  }

  showErrorAlert(error: ErrorResponse) {
    this.is_alert = true;
    console.log(this.tag, 'Error', error);
    if (error.errorCode != null) {
      if (error.errorCode == NOT_FOUND) {
        this.alertNoInformationFoundError.present();
      } else if (error.errorCode == INVALID_FORMAT) {
        this.alertInvalidFormatError.present();
      } else if (error.errorCode == SERVER_ERROR) {
        this.alertServerError.present();
      } else if (error.errorCode == UNKNOWN_ERROR) {
        this.alertUnknownError.present();
      } else if (error.errorCode == CONFIGURATION_ERROR) {
        this.alertConfigurationError.present();
      }
    } else {
      this.alertServerError.present();
    }
  }

  dismissLoading() {
    if (this.loading && this.is_loading) {
      console.log(this.tag, 'Trying to dismiss');
      this.loading.dismiss();
    }
    this.is_loading = false;
  }

  dismissAlerts() {
    this.is_alert = false;
    if (this.alertServerError) {
      this.alertServerError.dismiss();
      this.initAlertServerError();
    }
    if (this.alertNoInformationFoundError) {
      this.alertNoInformationFoundError.dismiss();
      this.initAlertNoInformationFoundError();
    }
    if (this.alertInvalidFormatError) {
      this.alertInvalidFormatError.dismiss();
      this.initAlertInvalidFormatError();
    }
    if (this.alertReaderError) {
      this.alertReaderError.dismiss();
      this.initAlertReaderError();
    }
    if (this.alertReaderDisconnectedError) {
      this.alertReaderDisconnectedError.dismiss();
      this.initAlertReaderDisconnectedError();
    }
  }

  // if !tag will show a dialog message modal
  showError(tagID) {
    if (!this.is_alert) {

      let alert = this.alertCtrl.create({
        title: this.translate.instant('identify_tag.alerts.dialog_item_lookup.title'),
        subTitle: this.translate.instant('identify_tag.alerts.dialog_item_lookup.unable_to_find') + " " + tagID,
        buttons: [
          {
            text: this.translate.instant('identify_tag.alerts.dialog_item_lookup.ok'),
            handler: () => {
              console.log(this.tag, 'Ok clicked');
              this.is_alert = false;
            }
          }

        ]
      });
      this.is_alert = true;
      alert.present();

    }
  }

  // Call barcode or rfid configuration when option selected
  radioButtonChangeMethod(value) {
    if (value == "barcode") {
      this.barcodeChecked = true;
      this.is_resopnse_tag = false;
      this.changeBarcodeMode();
    }
    else if (value == "rfid") {
      this.barcodeChecked = false;
      this.changeRFIDMode();
    }
  }

  // Changes configuration to barcode when radio button value=barcode
  changeBarcodeMode() {
    this.clearVariables(true);
    this.readerService.isDeviceBarcode().subscribe(
      (result) => {
        if (result) {
          console.log(this.tag, 'Device is barcode enabled');
          this.readerService.initScanDeviceBarcode().subscribe(
            (result: TagReadBarcodeResponse) => {
              console.log(this.tag, result);
              if (result.value != null) {
                //Send the value only is barcode is checked
                if (this.barcodeChecked) {
                  this.ShowTagScanned(result.value);
                  // this.changeBarcodeMode();
                }
              }
            },
            (error) => {
              console.log(this.tag, 'Error in device barcode initialization');
              console.log(this.tag, error);
            }
          );
        } else {
          console.log(this.tag, 'Device is not barcode enabled');
        }

        if (!this.readerService.continueWithoutReader) {
          this.initReaderBarcode();
        }
      },
      (error) => {
        console.log(this.tag, error);
      }
    );
  }

  initReaderBarcode() {
    console.log(this.tag, 'Initializing Reader barcode');
    this.readerService.initBarcodeScan().subscribe(
      (response: any) => {
        this.barcodeAttempts = 0;
        // Tag read
        console.log(this.tag, response.value);
        this.dismissAlerts();
        this.ShowTagScanned(response.value);
        // this.processTag(tagResponse);
      }, (error) => {
        console.log('ERROR', error);
        if (error.code == 800 && this.barcodeAttempts <= 3) {
          this.barcodeAttempts++;
          setTimeout(() => {
            this.initReaderBarcode();
          }, 500);
        }
      }
    );
  }

  stopReader() {

    this.readerService.stopScan().subscribe(
      (response: any) => {
        // Tag read
        console.log(this.tag, response);
        // this.processTag(tagResponse);
      }, (error) => {
        console.log(this.tag, 'ERROR', error);
      }
    );

  }

  // Changes configuration to rfid when radio button value=rfid
  changeRFIDMode() {
    this.clearVariables(true);
    this.readRFIDSubscription = this.readerService.initSingleScan().subscribe(
      (response: any) => {
        if (this.inputErrorTimeout) {
          clearTimeout(this.inputErrorTimeout);
          this.inputErrorTimeout = null;
        }
        this.inputError = '';
        // Tag read
        console.log(this.tag, 'Single Tag response', response.value);
        if (response.value === '3001') {
          this.clearVariables(true);
          this.ngZone.run(() => {
            this.inputError = 'tooManyTagsFound';
          });
          this.inputErrorTimeout = setTimeout(() => {
            this.ngZone.run(() => {
              this.inputError = '';
            })
          }, 3000);
        } else {
          this.ShowTagScanned(response.value);
        }
        this.dismissAlerts();
        // this.processTag(tagResponse);
      }, (error) => {
        console.log(this.tag, 'ERROR', error);
      }
    );
  }

  ShowTagScanned(readerScan: string) {
    if (!this.is_loading) {
      this.tagText = readerScan.toUpperCase();
      this.cdr.detectChanges();
      this.validateAndHideKeyboard(this.tagText);
    }
  }

  // Clear input tagTex value
  clearVariables(clearInputText?: boolean) {
    if (clearInputText) {
      this.tagText = '';
    }
    this.tagInformationService.reset(this.source);
    this.cdr.detectChanges();
  }

  goBack() {
    if (!this.isPopActive && !this.is_alert && !this.is_loading) {
      this.isPopActive = true;
      this.navCtrl.pop();
    }
  }

  ionViewWillEnter() {
    if (!this.isFirstLoadInitializing) {
      this.showLoadingInitializingReader();
    }

    this.readerService.isConnected(true).subscribe(
      (response: any) => {
        console.log(this.tag, 'Reader connected', response);
        if (response) {
          if (this.radioButtonBarcode.checked) {
            this.changeBarcodeMode();
          } else if (this.radioButtonRFID.checked) {
            this.changeRFIDMode();
          }
        }
        else {
          this.rfidChecked = false;
          this.radioButtonRFID.checked = false;
          this.barcodeChecked = true;
          this.isRfidDisabled = true;
          this.changeBarcodeMode();
          this.cdr.detectChanges();
        }
      }, (error) => {
        console.log(this.tag, 'Error', error);
        this.rfidChecked = false;
        this.radioButtonRFID.checked = false;
        this.barcodeChecked = true;
        this.isRfidDisabled = true;
        this.changeBarcodeMode();
        this.cdr.detectChanges();
      }
    );
    this.platform.registerBackButtonAction(() => {
      if (!this.is_alert && !this.is_loading) {
        this.goBack();
      }
    });
    this.initReaderStatusListener();
    if (!this.isFirstLoadInitializing) {
      this.dismissLoading();
    }
    this.isFirstLoadInitializing = false;
    this.cdr.reattach();
    this.cdr.detectChanges();
  }

  private initReaderStatusListener() {
    console.log(this.tag, 'Initializing Reader Status Listener');
    this.readerDisconnectSubscription = this.readerService.setStatusListener().subscribe((response) => {
      console.log(this.tag, 'Status');
      console.log(this.tag, response);
      if (response.hasOwnProperty('connected') && !response.connected) {
        console.log(this.tag, 'Reader disconnected!');
        this.rfidChecked = false;
        this.radioButtonRFID.checked = false;
        this.barcodeChecked = true;
        this.isRfidDisabled = true;

        this.changeBarcodeMode();
        this.cdr.detectChanges();
      }
    }, (error) => {
      console.log(this.tag, 'Error Connecting to the reader');
      // this.is_alert = true;
      // this.alertReaderError.present();
    });
  }

  onFinishedLoadingDetails() {

  }

  onErrorLoadingDetails(error) {
    if(!this.isPopActive) {
      if(!this.is_alert){
        this.showErrorAlert(error);
      }
      this.clearVariables();
    }
  }

  onNoInformationFound() {
    this.is_alert = true;
    this.alertNoInformationFoundError.present();
    this.clearVariables();
  }
  onChangeKeyValue(event)
  {
    let charPressed = event.charAt(event.length - 1);
    if (!charPressed) {
      charPressed = '';
    }
    let regExpression = new RegExp(VALIDATION_INPUT_TAG);
    if (!regExpression.test(<string>charPressed.toUpperCase())) {
      this.tagText = event.replace(charPressed, '');
      this.inputTagField.value = this.tagText;
    }
    else {
      this.tagText = event;
    }
    this.cdr.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./src/pages/identify-tag/identify-tag.ts